import { post } from "@/utils/utils";
// 导购相关接口
const home = {
  state: {
    marketList: {},
    dynamicList: {
      totalGetCashCommission: "0",
      totalPayGetCashCommission: "0"
    },
    analysisList: {}
  },
  mutations: {
    MARKET(state, data) {
      state.marketList = data.result;
    },
    DYNAMIC(state, data) {
      state.dynamicList = data.result;
      state.dynamicList.totalPayGetCashCommission =
        state.dynamicList.totalPayGetCashCommission + "";
      state.dynamicList.totalGetCashCommission =
        state.dynamicList.totalGetCashCommission + "";
    },
    ANALYSIS(state, data) {
      state.analysisList = data.result;
    },
    QUERY_USED_LIST() {}
  },
  actions: {
    queryMarket({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/index/market`,
        name: "MARKET",
        params
      });
    },
    queryDynamic({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/index/dynamic`,
        name: "DYNAMIC",
        params
      });
    },
    queryAnalysis({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/index/analysis`,
        name: "ANALYSIS",
        params
      });
    },
    queryUsedList({ commit }, params) {
      return post({
        commit,
        url: `/system/sysPersonalizedRecentUsageRecord/queryPageList`,
        name: "QUERY_USED_LIST",
        params
      });
    }
  }
};

export default home;
